import {
	createNamespacedHelpers
} from 'vuex';
import common from '@/util/common';
const sroreName = {
	login: 'login',
};
const {
	mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.login);
export default {
	data() {
		return {
			loginData: null, //登录cookie数据
			userName: '', //手机号
			cardId: '', //身份证
			clientHeight: '', //可视区域高度
			login_type: 'password',//登录方式
			psdValue: '',//登录密码
			getConfData: null,//系统配置信息
			wxAppid: 'wx39c6e5208437579c',//微信appid
			isSelectLoginFlag: false,//是否去选择登录界面，建行环境不去，非建行环境去，根据链接search是否有user_id判断
			user_id: '',//建行跳转该界面带的user_id参数
			loginWay: '',//登录环境，提供给支付用，建行环境0，非建行2
			isScrollTopFlag: false,//是否往上移动，用在安卓建行环境下，聚焦input输入框时
			isAndroid: false,//判断是否是安卓浏览器
			show:false,
			expendCard:['card1','card2'],
			noticeList:[] //公告列表
		};
	},
	async created(){
		console.log('获取浏览器信息',window.navigator.userAgent,'获取完毕')
		this.isAndroid = this.isAndroidHandle();
		//await this.isSelectLoginWay();
        // await this.getConfInfo();

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)){
          common.jump(this,'myInfo');
		}

	},
	async mounted() {
		this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
		this.setInfo();
		this.screenResize();
		this.getConfInfo();
	},
	components: {

	},
	watch: {

	},
	computed: {
		...mapState({
			userInfo(state) {
				return state.userInfo
			}
		})
	},
	methods: {
		...mapActions({
			login: 'login',
			getConf: 'getConf',
			postWxLogin: 'postWxLogin',
			postRedirect: 'postRedirect',
			bankAutoLogin: 'bankAutoLogin'
		}),
		mobileInput(){
			const len = this.userName.length;
			if(len > 11){
				this.$refs.userName.value = this.userName = this.userName.substring(0,11);
			}
		},
		async getConfInfo(){
			const param = {
				content: this,
				data: {
					page: 'PC',
				}
			};
			const result = await this.getConf(param);
			if (result && 1 == result.code){
				this.noticeList = result.data
			}
		},
		jumpPage(e){
			common.jumpPage(this,e.currentTarget);
		},
		async postRedirectHandle(code){
			const param = {
				content: this,
				data: {
					code: code,
				}
			};
			const redirectData = await this.postRedirect(param);
			console.log('redirectData',redirectData);
			if (redirectData && redirectData.code == 1) {
				this.loginCallBack(redirectData);
			}
		},
		async submit() {
			const param = {
				content: this,
				url: 'index.php/api/user/getAccountByPassword',
				data: {
          cert_no: this.userName,
          password: this.psdValue,
					udid: this.user_id
				}
			};
			const loginData = await this.login(param);
			if (loginData && loginData.code == 1) {
				if (!this.loginData || this.loginData.userName != this.userName) {
					const d = new Date();
					let cookieData = {
						userName: this.userName,
						psdValue: this.psdValue
					};
					d.setTime(d.getTime() + (90 * 24 * 60 * 60 * 1000));
					common.Cookie().setAll('loginData', cookieData, d);
				}
				this.loginCallBack(loginData);
			}
		},
		loginCallBack(loginData){
			console.log('登录回调',loginData);
			const accountNo = loginData.data.AccountNo?loginData.data.AccountNo:[];
			const accountNoLen = accountNo.length;
			const configInfo = {
				...this.getConfData.data,
				AccountNo: accountNo,
				loginWay: this.loginWay,
				loginSearch: location.search
			};
			console.log('configInfo',configInfo);
			sessionStorage.setItem('configInfo',JSON.stringify(configInfo));
			document.cookie = `${encodeURIComponent("token")}=${encodeURIComponent(loginData.data.token)}`;
			if(accountNoLen == 0 || accountNoLen > 1){
				common.jump(this,'cardList');
			}else{
				common.jump(this,'myInfo');
			}
		},
		setInfo() {
			this.loginData = common.Cookie().getAll('loginData');
			console.log('loginData', this.loginData);
			if (this.loginData) {
				this.userName = this.loginData.userName;
				this.psdValue = this.loginData.psdValue;
				// if(this.login_type === 'personId' || this.login_type === 'other'){
				// 	this.cardId = this.loginData.cardId;
				// }else if(this.login_type === 'password'){
				// 	this.psdValue = this.loginData.psdValue;
				// }
			}
		},
		/* 监控可是区域高度变化 */
		screenResize() {
			window.onresize = () => {
				const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
				const marginTop = clientHeight - this.clientHeight;
				this.$refs.loginContainer.style.marginTop = (2*marginTop)/3 + 'px';
			}
		},
		helpHandle(e){
			const currentTarget = e.currentTarget;
			this.$router.push({
				name: 'register',
				query: {
					type: currentTarget.dataset.type
				}
			})
		},
		async wxlogin(){
			const href = location.href;
			const url = href.split('?')[0];
			const redirect_uri = encodeURIComponent(url);
			console.log(url,redirect_uri)
			const param = {
				content: this
			};
			const wxLoginData = await this.postWxLogin(param);
			if(wxLoginData && wxLoginData.code == 1){
				this.wxAppid = wxLoginData.data;
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
			}
		},
		async isSelectLoginWay(){
			const getSearch = decodeURIComponent(location.search);
			const createSearchObject = new URLSearchParams(getSearch);
			const isSelectLoginFlag = createSearchObject.has('user_id') || createSearchObject.has('u');
			const isHasWxCode = createSearchObject.has('code');//点击微信登录返回到该页面时，界面地址后面会带code
			const isBankAutoLoginFlag = createSearchObject.has('isBankAutoLoginFlag');//是否自动登录，首页点注销之后赋值
			console.log(getSearch,isSelectLoginFlag);
			if(isSelectLoginFlag){
				this.user_id = createSearchObject.get('user_id') || '';
				this.loginWay = 0;
				console.log('建行自动登录',this.user_id)
				await this.bankAutoLoginHandle();
			}else if(isBankAutoLoginFlag){
				console.log('建行注销不走自动登录');
				this.loginWay = 0;
				await this.getConfInfo();
			}else{
				const {isWxLoginFlag = '0'} = common.getQuery(this) || {};
				if(isWxLoginFlag == 1 || isHasWxCode){
					console.log('微信登录',isWxLoginFlag);
					this.loginWay = 2;
					await this.getConfInfo();
				}else{
					common.jump(this,'selectLoginWay');
				}
			}
		},
		async bankAutoLoginHandle(){
			const param = {
				content: this,
				data: {
					udid: this.user_id,
				}
			};
			const bankAutoLoginData = await this.bankAutoLogin(param);
			console.log('bankAutoLoginData',bankAutoLoginData);
			if(bankAutoLoginData && bankAutoLoginData.code == 1){
				console.log('bankAutoLoginData',bankAutoLoginData);
				await this.getConfInfo();
				this.loginCallBack(bankAutoLoginData);
			}else{
				console.log('建行正常账号密码登录');
				await this.getConfInfo();
			}
		},
		isAndroidHandle(){
			const userAgent = window.navigator.userAgent;
			return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
		},
		scrollTopHandle(flag){
			console.log('flag',flag,this.loginWay,this.isAndroid);
			if(flag && this.loginWay === 0 && this.isAndroid){
				this.isScrollTopFlag = true;
			}else{
				this.isScrollTopFlag = false;
			}
		},
		toExpendCard(type){
			let expendCard = this.expendCard
			let isExist= expendCard.includes(type)
			if(!isExist){
				expendCard.push(type)
			}else{
				let index = expendCard.findIndex(item=>{
					return type === item
				})
				expendCard.splice(index,1)
				this.expendCard=expendCard
			}

		},
		toAskCourse(){

    },
		toApplyCourse(){
			common.jump(this,'apply');
		}
	}
};
